import { IconButton, SvgIcon } from '@mui/material'

interface P {
    isRequired: boolean
    onToggle: () => void
    isDefault: boolean
}

function RequiredButton({ isRequired, onToggle, isDefault }: P) {
    return (
        <IconButton
            disabled={isDefault}
            onClick={e => {
                e.stopPropagation()
                onToggle()
            }}>
            <SvgIcon
                color={isRequired ? 'error' : 'inherit'}
                viewBox='0 0 15 17'>
                <path
                    d='M7.50017 1V8.5M7.50017 8.5V16M7.50017 8.5L1.00017 4.75M7.50017 8.5L14.0002 12.25M7.50017 8.5L14.0002 4.75M7.50017 8.5L1.00017 12.25'
                    stroke='currentColor'
                    strokeOpacity='0.56'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </SvgIcon>
        </IconButton>
    )
}

export default RequiredButton
